import React, { useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { CircularProgress, Grid } from '@mui/material';


const topLabelsPlugin = {
  id: 'topLabels',
  afterDatasetsDraw(chart) {
    const { ctx, data } = chart;
    chart.getDatasetMeta(0).data.forEach((bar, index) => {
      const value = data.datasets[0].data[index];
      ctx.save();
      ctx.fillStyle = '#AC0FE4';
      ctx.font = 'bold 13px sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'bottom';
      ctx.fillText(value, bar.x, bar.y - 4);
      ctx.restore();
    });
  },
};

// Register the components you need for this specific chart
Chart.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  topLabelsPlugin
);

const DashboardBarGraph = ({ graph, isLoading }) => {

  const data = {
    labels: graph.map(g => g?.month),
    datasets: [{
      label: 'Total Count',
      data: graph.map(g => g?.total_count),
      backgroundColor: "#DD7DFF",
      borderColor: 'rgba(153, 102, 255, 1)', // Use a purple color for the border
    }]
  };

  const options = {
    responsive: true,
    layout: {
    padding: {
      top: 25, // ← room for the top labels
    },
  },
    scales: {
      x: {
        display: true, // Display the x-axis labels
        grid: {
          display: false, // Hide x-axis grid lines
          drawBorder: false, // Hide x-axis line
        },
        ticks: {
          autoSkip: false,
          display: true, // Show x-axis labels
          color: "black"
        }
      },
      y: {
        display: false, // Hide the y-axis completely
        grid: {
          display: false, // Hide y-axis grid lines
          drawBorder: false, // Hide y-axis line
        },
        ticks: {
          display: false, // Hide y-axis labels
        },
        suggestedMax: Math.max(...graph.map(g => g?.total_count ?? 0)) * 1.2,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        color: '#C933FF',
        anchor: 'end',
        align: 'top',
        formatter: function (value, context) {
          return value;
        }
      }
    },
  };



  return (
    <>
      {isLoading ?
        <Grid
          height={"50vh"}
          xs={12}
          container
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CircularProgress size={40} />
        </Grid>
        :
        <Bar className='admin-bar' data={data} options={options} />}
    </>
  )
};

export default DashboardBarGraph;
